import Vue from 'vue'
import Router from 'vue-router'
import queryString from '@spero/spero-utils/src/helpers/queryString'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

const numReg = /(\d+)/

const router = new Router({
  routes: [
    {
      path: '/course/:id',
      name: 'course',
      component: () => import('../pages/course.vue'),
      props: true,
      meta: {
        title: '',
        noTopSafe: 1,
        paramsReg: {
          id: numReg
        }
      }
    },
    {
      path: '/article-list/:id',
      name: 'article-list',
      component: () => import('@/pages/article-list'),
      props: true,
      meta: {
        navigator: true,
        title: '',
        paramsReg: {
          id: numReg
        }
      }
    },
    {
      path: '/play-list/:id',
      name: 'play-list',
      component: () => import('@/pages/play-list'),
      props: true,
      meta: {
        navigator: true,
        title: '',
        paramsReg: {
          id: numReg
        }
      }
    },
    {
      path: '/intro/:id',
      name: 'courseIntro',
      component: () => import('@/pages/intro'),
      props: true,
      meta: {
        navigator: true,
        title: '',
        paramsReg: {
          id: numReg
        }
      }
    },
    {
      path: '/activate',
      name: 'activate',
      component: () => import('@/pages/activate-list'),
      meta: {
        navigator: true,
        title: ''
      }
    },
    {
      path: '/down',
      name: 'down',
      component: () => import('@/pages/down'),
      meta: {
        navigator: true,
        title: '下载股拍APP'
      }
    },
    {
      path: '/questionnaire/:id',
      name: 'questionnaire',
      component: () => import('@/pages/questionnaire'),
      props: true,
      meta: {
        // navigator: true,
        title: '',
        paramsReg: {
          id: numReg
        }
      }
    },
    {
      path: '/class/:classId',
      name: 'courseIntro',
      component: () => import('@/pages/class.vue'),
      props: true,
      meta: {
        noGlobalLogin: 1,
        title: '',
        paramsReg: {
          classId: numReg
        }
      }
    }
  ]
})

// function updateTitle (title) {
//   document.title = title
// }

router.beforeEach(async (to, from, next) => {
  const tag = Math.round(new Date().getTime() / 60 / 1000) + ''
  const {origin, pathname, search, hash} = location
  const q = queryString.query(search)

  if (!q.t) {
    q.t = tag
    return location.replace(`${origin}${pathname}${queryString.objToStr(q)}${hash}`)
  }

  if (to.meta.paramsReg) {
    for (let k in to.meta.paramsReg) {
      let reg = to.meta.paramsReg[k]
      to.params[k] = reg.exec(to.params[k]) && RegExp.$1
    }
  }
  next()
})

export default router
